/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSkull = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M17.75 17.062a8 8 0 1 0-11.5 0v3.188h11.5zm-.626-1.562s-.182.246-.874 1v2.25H14.5V17H13v1.75h-2V17H9.5v1.75H7.75V16.5c-.727-.8-.874-1-.874-1a6.5 6.5 0 1 1 10.248 0" clipRule="evenodd" /><path fill="currentColor" d="m12 12 1.75 3h-3.5zM10 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M17 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" /></svg>;
export default SvgSkull;